<template>
    <div class="template-detail-page">
        <div class="page-tools-content" style="margin: 0;">
            <div class="left">
                <el-button ref="saveBtn" size="small" type="primary" round :loading="saveLoading" @click="saveTemplateBtnEvent">{{$t('project.project_templateDetail_page_btn_6')}}</el-button>
            </div>
            <div class="right"></div>
        </div>
        <el-tabs class="filter-tabs" v-model="activeTab" @tab-click="settingTabChange">
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_1')" name="basic">
            <el-alert type="warning" center>{{$t('project.project_templateDetail_page_tips_1')}}<kbd>Ctrl/⌘</kbd> + <kbd>S</kbd></el-alert>
            <div class="bg-white border-b padding-y-15 padding-x-30">
                <div class="fonts-12 margin-b-10"><span class="color-error margin-r-5">*</span>{{$t('project.project_templateDetail_page_tips_2')}}</div>
                <el-input v-model="setting.templateName" :placeholder="$t('project.project_templateDetail_page_placeholder_1')" size="small" clearable style="width: 500px;"></el-input>
            </div>
            <div class="bg-white border-b padding-y-15 padding-x-30">
                <div class="fonts-12 margin-b-10"><span class="color-error margin-r-5">*</span>{{$t('project.project_templateDetail_page_tips_3')}}</div>
                <el-select v-model="setting.teamId" :placeholder="$t('project.project_templateDetail_page_placeholder_2')" size="small" style="width: 300px;">
                    <template v-for="(item, index) in teamOptions">
                        <el-option :label="item.text" :value="item.value" :key="index"></el-option>
                    </template>
                </el-select>
            </div>
            <div class="bg-white border-b padding-y-15 padding-x-30">
                <div class="fonts-12 margin-b-10"><span class="color-error margin-r-5">*</span>{{$t('project.project_templateDetail_page_tips_4')}}</div>
                <el-select v-model="setting.translationProcessMode" :placeholder="$t('project.project_templateDetail_page_placeholder_3')" size="small" style="width: 300px;">
                    <template v-for="(item, index) in workflowOptions">
                        <el-option :label="item.description" :value="item.name" :key="index"></el-option>
                    </template>
                </el-select>
            </div>
            <div class="bg-white border-b padding-y-15 padding-x-30">
                <div class="fonts-12 margin-b-10"><span class="color-error margin-r-5">*</span>{{$t('project.project_templateDetail_page_tips_5')}}</div>
                <div class="flex flex-align-center">
                    <el-select v-model="setting.sourceLang" @change="sourceLangChangeEvent" filterable size="small" :placeholder="$t('project.project_templateDetail_page_placeholder_4')" style="width: 200px;">
                        <template v-for="(value, key) in LANGUAGE_DICT">
                            <el-option :label="value.name" :value="value.key" :key="key"></el-option>
                        </template>
                    </el-select>
                    <svg-icon name="ib-arrow-right" className="margin-x-5"></svg-icon>
                    <el-select v-model="setting.targetLang" @change="targetLangChangeEvent" :disabled="!setting.sourceLang" multiple collapse-tags clearable filterable size="small" :placeholder="$t('project.project_templateDetail_page_placeholder_5')" style="width: 280px;">
                        <template v-for="(value, key) in LANGUAGE_DICT">
                            <el-option :label="value.name" :value="value.key" :key="key" v-if="value.key !== setting.sourceLang"></el-option>
                        </template>
                    </el-select>
                </div>
                <div class="margin-t-10">
                    <table class="setting-engine-table">
                        <thead>
                            <th width="200">{{$t('project.project_templateDetail_page_tips_5')}}</th>
                            <th width="200">{{$t('project.project_templateDetail_page_tips_6')}}</th>
                            <th width="200">{{$t('project.project_templateDetail_page_tips_7')}}</th>
                        </thead>
                        <tbody>
                            <template v-if="setting.projectSetting?.multilingualSetting.length">
                                <tr v-for="(item, index) in setting.projectSetting?.multilingualSetting" :key="index">
                                    <td>
                                        <language-direction :source="item.sourceLang" :target="item.targetLang" type="half" class="fonts-14"></language-direction>
                                    </td>
                                    <td>
                                        <el-select v-model="item.engine" size="small" filterable :placeholder="$t('project.project_templateDetail_page_placeholder_6')">
                                            <el-option-group>
                                                <el-option :label="$t('project.project_templateDetail_page_tips_8')" value="NONE" key="NONE"></el-option>
                                            </el-option-group>
                                            <template v-for="domain in item.engineOptions">
                                                <el-option-group :label="domain.name" :key="domain.key" v-if="domain.engines.length > 0">
                                                    <el-option v-for="engine in domain.engines" :value="engine.key" :key="engine.key" :label="engine.name">
                                                        <div class="flex flex-align-center">
                                                            <svg-icon :name="`ie-${engine.icon}`" className="margin-r-10 fonts-20"></svg-icon>
                                                            <span>{{engine.name}}</span>
                                                        </div>
                                                    </el-option>
                                                </el-option-group>
                                            </template>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-select v-model="item.randomEngine" size="small" clearable :placeholder="$t('project.project_templateDetail_page_placeholder_7')" style="width: 100%">
                                            <template v-for="domain in item.referenceEngineOptions">
                                                <el-option v-for="engine in domain.engines" :value="engine.key" :key="engine.key" :label="engine.name">
                                                    <div class="flex flex-align-center">
                                                        <svg-icon :name="`ie-${engine.icon}`" className="margin-r-10 fonts-20"></svg-icon>
                                                        <span>{{engine.name}}</span>
                                                    </div>
                                                </el-option>
                                            </template>
                                        </el-select>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="3"><div class="text-center fonts-12 color-999">{{$t('project.project_templateDetail_page_tips_9')}}</div></td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="bg-white border-b padding-y-15 padding-x-30">
                <div class="fonts-12 margin-b-10">
                    {{$t('project.project_templateDetail_page_tips_10')}}
                    <el-tooltip placement="top-start">
                        <div class="line-height-1.5" slot="content">
                            <div>{{$t('project.project_templateDetail_page_tips_11')}}</div>
                            <div>{{$t('project.project_templateDetail_page_tips_12')}}</div>
                        </div>
                        <svg-icon name="ib-question" class="fonts-14"></svg-icon>
                    </el-tooltip>
                </div>
                <div class="flex flex-align-center">
                    <div class="fonts-12" style="width: 90px;">{{$t('project.project_templateDetail_page_tips_13')}}</div>
                    <div class="flex-1 setting-grid">
                        <template v-for="(item, index) in setting.projectSetting.autoReplaceSettings">
                            <div class="item" :key="index">
                                <el-checkbox v-model="item.checked" :label="item.name"></el-checkbox>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="flex flex-align-center margin-t-15">
                    <div class="fonts-12" style="width: 90px;">{{$t('project.project_templateDetail_page_tips_14')}}</div>
                    <div class="flex-1 setting-grid">
                        <template v-for="(item, index) in setting.projectSetting.analysisSettings">
                            <div class="item" :key="index">
                                <el-checkbox v-model="item.lock" :label="item.name"></el-checkbox>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="flex flex-align-center margin-t-15">
                    <div class="fonts-12" style="width: 90px;">{{$t('project.project_templateDetail_page_tips_15')}}</div>
                    <div class="flex-1 setting-grid">
                        <template v-for="(item, index) in setting.projectSetting.analysisSettings">
                            <div class="item" :key="index" v-if="!['AUTO_REPLACE', 'LOW_RISK_SENTENCE'].includes(item.type)">
                                <el-checkbox v-model="item.calculate" :label="item.name"></el-checkbox>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="bg-white border-b padding-y-15 padding-x-30" v-if="templateId">
                <div class="flex" style="gap: 30px;">
                    <div>
                        <div class="fonts-12 margin-b-10">{{$t('project.project_templateDetail_page_tips_16')}}</div>
                        <div>{{ setting.creatorName }}</div>
                    </div>
                    <div>
                        <div class="fonts-12 margin-b-10">{{$t('project.project_templateDetail_page_tips_17')}}</div>
                        <div>{{ setting.createTime }}</div>
                    </div>
                    <div>
                        <div class="fonts-12 margin-b-10">{{$t('project.project_templateDetail_page_tips_18')}}</div>
                        <div>{{ setting.updateTime }}</div>
                    </div>
                </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_2')" name="memory">
            <div class="flex flex-justify-between margin-y-15" v-if="setting.sourceLang && setting.targetLang.length">
                <div class="flex flex-align-center">
                    <div class="flex flex-align-center fonts-14 margin-r-10">
                        <div>{{ LANGUAGE_DICT[setting.sourceLang]?.name }}</div>
                        <svg-icon name="ib-arrow-right" class="margin-x-5"></svg-icon>
                        <el-select v-model="memLangValue" @change="memLangSelectChange" size="mini" style="width: 140px;">
                            <template v-for="(item, index) in setting.targetLang">
                                <el-option :key="index" :value="item" :label="LANGUAGE_DICT[item].name"></el-option>
                            </template>
                        </el-select>
                    </div>
                    <div>
                        <el-button size="mini" plain round @click="gotoMemoryPage" icon="el-icon-plus">{{$t('project.project_templateDetail_page_btn_1')}}</el-button>
                        <el-button size="mini" plain round @click="initMemoryList(memLangValue)" icon="el-icon-refresh-right">{{$t('project.project_templateDetail_page_btn_2')}}</el-button>
                    </div>
                </div>
                <div class="fonts-13 mem-matching-setting">
                    <span class="margin-r-10"><span class="color-error fonts-16" style="margin-right:1px;">*</span>{{$t('project.project_templateDetail_page_tips_19')}}</span>
                    <el-select :placeholder="$t('project.project_templateDetail_page_placeholder_8')" v-model="setting.memMatchingRate" size="mini" style="width:78px;">
                        <template v-for="item in memMatchingOptions">
                            <el-option :label="item" :value="item" :key="item"></el-option>
                        </template>
                    </el-select>
                </div>
            </div>
            <el-table ref="memoryTable" :data="memoryList" row-key="memId" style="width: 100%" @selection-change="handleMemoryTableSelectionChange">
                <el-table-column type="selection" :reserve-selection="true" width="50"></el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_1')" width="80">
                    <template slot-scope="scope">
                        <el-switch :value="setting.writeableMemId.includes(scope.row.memId)" active-color="#1AC49C" @change="val => handleMemoryWriteChange(val, scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_2')">
                    <template slot-scope="scope">
                        <router-link :to="{path:'/asset/memory/detail',query:{id:scope.row.memId}}" target="_blank">{{scope.row.name}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_3')">
                    <template slot-scope="scope">
                        <language-direction :source="scope.row.sourceLang" :target="scope.row.targetLang" type="half"></language-direction>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_4')" prop="nums" min-width="25%">
                    <template slot-scope="scope">
                        <span>{{ scope.row.nums }} {{$t('project.project_templateDetail_page_tips_20')}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_5')" width="180">
                    <template slot-scope="scope">
                        <el-input-number size="mini" 
                            :disabled="getMemoryPenaltyPointsInputStatus(scope.row)" 
                            v-model="scope.row.setting[0].penaltyPoints" 
                            @change="val => handleMemoryPenaltyPointsChange(val, scope.row)" 
                            controls-position="right" :step="1" :precision="0" :min="0" :max="15" 
                            style="width: 100px;">
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_6')" prop="createTime" min-width="25%"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_3')" name="term">
            <div class="flex flex-align-center" v-if="setting.sourceLang && setting.targetLang.length">
                <div class="flex flex-align-center fonts-14 margin-r-10">
                    <div>{{ LANGUAGE_DICT[setting.sourceLang]?.name }}</div>
                    <svg-icon name="ib-arrow-right" class="margin-x-5"></svg-icon>
                    <el-select v-model="termLangValue" @change="termLangSelectChange" size="mini" style="width: 140px;">
                        <template v-for="(item, index) in setting.targetLang">
                            <el-option :key="index" :value="item" :label="LANGUAGE_DICT[item].name"></el-option>
                        </template>
                    </el-select>
                </div>
                <div class="margin-y-15">
                    <el-button size="mini" plain round @click="gotoTermPage" icon="el-icon-plus">{{$t('project.project_templateDetail_page_btn_1')}}</el-button>
                    <el-button size="mini" plain round @click="initTermsList(termLangValue)" icon="el-icon-refresh-right">{{$t('project.project_templateDetail_page_btn_2')}}</el-button>
                </div>
            </div>
            <el-table ref="termsTable" :data="termsList" row-key="termId" max-height="480" style="width: 100%" @selection-change="handleTermsTableSelectionChange">
                <el-table-column type="selection" :reserve-selection="true" width="50"></el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_1')" width="80">
                    <template slot-scope="scope">
                        <el-switch :value="setting.writeableTermId.includes(scope.row.termId)" active-color="#1AC49C" @change="val => handleTermWriteChange(val, scope.row)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_2')">
                    <template slot-scope="scope">
                        <router-link :to="{path:'/asset/term/detail',query:{id:scope.row.termId}}" target="_blank">{{scope.row.name}}</router-link>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_3')">
                    <template slot-scope="scope">
                        <language-direction :source="scope.row.sourceLang" :target="scope.row.targetLang" type="half"></language-direction>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_4')" prop="nums" min-width="25%">
                    <template slot-scope="scope">
                        <span>{{ scope.row.nums }} {{$t('project.project_templateDetail_page_tips_20')}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_6')" prop="createTime" min-width="25%"></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_4')" name="docSetting">
            <template v-for="(item, index) in setting.projectSetting.docSetting">
                <div class="doc-config-card" :key="index">
                    <div class="flex flex-align-center">
                        <el-tooltip :content="item?.name" placement="top">
                            <div class="doc-icon file-word flex flex-justify-center flex-align-center">
                                <svg-icon :name="'ic-' + item.icon" style="width: 17px;height: 17px;"></svg-icon>
                            </div>
                        </el-tooltip>
                        <div class="check-all margin-l-30" style="width: 87px;">
                            <el-checkbox v-model="item.checkAll" 
                                :indeterminate="item.indeterminate" 
                                @change="val=>docSettingCheckAllChange(val,index)">
                                {{$t('project.project_templateDetail_page_tips_21')}}
                            </el-checkbox>
                        </div>
                        <div class="flex-1">
                            <div class="options-list">
                                <template v-for="(opt, oIndex) in item.options">
                                    <div class="margin-r-30"  :key="oIndex">
                                        <el-checkbox v-model="opt.value" 
                                            :label="opt.value" 
                                            @change="val=>docSettingCheckChange(val,index,oIndex)">
                                            {{opt.label}}
                                        </el-checkbox>
                                        <template v-if="opt.key === 'multiColumn'">
                                            <el-tooltip :content="$t('project.project_create_page_form_label_15')" placement="top">
                                                <el-button @click="showMultiColumnExcelParseDialogEvent" type="text" :disabled="!opt.value" class="margin-l-2 padding-0">
                                                    <svg-icon name="ib-setting" class="fonts-18"></svg-icon>
                                                </el-button>
                                            </el-tooltip>
                                        </template>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
          </el-tab-pane>
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_5')" name="qa">
            <div class="qa-setting-panel" v-if="setting.projectSetting.qaSetting">
                <div class="option-wrapper" style="border-bottom: 1px solid #e5e5e5;">
                    <div class="block-title">{{$t('project.project_templateDetail_page_tips_22')}}</div>
                    <div class="option-list">
                        <template v-for="(item,index) in setting.projectSetting.qaSetting.options">
                            <div class="item" :key="index" v-if="item.type === 'BASIC'">
                                <el-checkbox v-model="item.selected" :disabled="!item.enabled" :label="item.description"></el-checkbox>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="option-wrapper" style="border-bottom: 1px solid #e5e5e5;">
                    <div class="block-title">
                        {{$t('project.project_templateDetail_page_tips_23')}}
                    </div>
                    <div class="option-list">
                        <template v-for="(item,index) in setting.projectSetting.qaSetting.options">
                            <div class="item" :key="index" v-if="item.type === 'AI'">
                                <el-checkbox v-model="item.selected" :disabled="!item.enabled" :label="item.description"></el-checkbox>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="option-wrapper">
                    <div class="block-title">
                        {{$t('project.project_templateDetail_page_tips_24')}}
                    </div>
                    <div class="option-list">
                        <div class="item">
                            <el-checkbox v-model="setting.projectSetting.qaSetting.checkQa" :label="$t('project.project_templateDetail_page_tips_25')"></el-checkbox>
                        </div>
                    </div>
                </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_6')" name="styleGuide">
            <div class="bg-white border-b padding-y-15 padding-x-30">
                <div class="fonts-12 margin-b-10">{{$t('project.project_templateDetail_page_tips_26')}}</div>
                <el-input v-model="setting.remark" :placeholder="$t('project.project_templateDetail_page_placeholder_9')" size="small" clearable style="width: 500px;"></el-input>
            </div>
            <div class="padding-y-15 border-b">
                <el-button plain round size="mini" icon="el-icon-plus" @click="remarkFileUpload.show = true">{{$t('project.project_templateDetail_page_btn_3')}}</el-button>
            </div>
            <el-table :data="setting.styleGuideDocs" style="width: 100%;">
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_7')" type="index"></el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_8')" prop="fileName"></el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_9')" prop="time"></el-table-column>
                <el-table-column :label="$t('project.project_templateDetail_page_table_column_10')" width="100px">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="deleteRemarkFile(scope)">
                        <svg-icon name="ib-trash-o" className="fonts-16"></svg-icon>
                    </el-button>
                </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="$t('project.project_templateDetail_page_dialog_1_title')" :visible.sync="remarkFileUpload.show" destroy-on-close :width="'520px'" top="20px">
                <div class="fonts-12 margin-b-15 text-center">{{$t('project.project_templateDetail_page_dialog_1_tips_1')}} <span class="color-link">10</span> {{$t('project.project_templateDetail_page_dialog_1_tips_2')}}</div>
                <!-- <div class="fonts-12 margin-b-15 text-center">{{remarkFileUpload.supportFiles}}</div> -->
                <upload-oss ref="remarkFileUploadDom"
                    :multiple="true"
                    :limit="10 - setting.styleGuideDocs.length"
                    :size="50"
                    :accept="remarkFileUpload.accept"
                    :params="{}"
                    :type="`STYLE_GUIDE`"
                ></upload-oss>
                <div slot="footer" class="text-center">
                    <el-button round plain size="small" @click="remarkFileUpload.show = false">{{$t('project.project_templateDetail_page_btn_4')}}</el-button>
                    <el-button round type="primary" size="small" :loading="remarkFileUpload.loading" @click="submitUploadRemarkFile">{{$t('project.project_templateDetail_page_btn_5')}}</el-button>
                </div>
            </el-dialog>
          </el-tab-pane>
          <el-tab-pane :label="$t('project.project_templateDetail_page_tab_pane_label_7')" name="autoScore">
            <el-form label-width="100px" size="small" class="margin-t-15">
                <el-form-item>
                    <template slot="label">
                        <span class="margin-r-5">{{$t('project.project_templateDetail_page_tips_27')}}</span>
                        <el-tooltip :content="$t('project.project_templateDetail_page_tips_28')" placement="top">
                            <svg-icon name="ib-question"></svg-icon>
                        </el-tooltip>
                    </template>
                    <el-switch v-model="setting.projectSetting.ratingSettings.enable" active-color="#1AC49C"></el-switch>
                </el-form-item>
                <el-form-item>
                    <template slot="label">
                        <span class="margin-r-5">{{$t('project.project_templateDetail_page_tips_29')}}</span>
                        <el-tooltip :content="$t('project.project_templateDetail_page_tips_30')" placement="top">
                            <svg-icon name="ib-question"></svg-icon>
                        </el-tooltip>
                    </template>
                    <el-input-number v-model="setting.projectSetting.ratingSettings.threshold" :step="10" :min="0" :max="90" :precision="0" controls-position="right"></el-input-number>
                </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <multi-column-excel-parse-dialog ref="multiColumnExcelParseRef" @save="saveMultiColumnSetting"></multi-column-excel-parse-dialog>
        <create-memory ref="createMemoryDialog" @success="ids => initMemoryList(memLangValue, ids)"></create-memory>
        <create-term ref="createTermDialog" @success="ids => initTermsList(termLangValue, ids)"></create-term>
    </div>
</template>
<script >
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { projectApi, commonApi, memoryApi, termApi, qaApi, } from '@/utils/api';
import config from '@/utils/config';
import LanguageDirection from '@/components/LanguageDirection';
import CreateTerm from '@/views/project/components/CreateTermMultiLanguage';
import CreateMemory from '@/views/project/components/CreateMemoryMultiLanguage';
import UploadOss from '@/components/UploadOss';
import MultiColumnExcelParseDialog from './components/MultiColumnExcelParseDialog.vue';
export default {
    components: {
        LanguageDirection, 
        CreateTerm, 
        CreateMemory, 
        UploadOss, 
        MultiColumnExcelParseDialog, 
    },
    data() {
        return {
            config,
            templateId: '',
            saveLoading: false,
            activeTab: 'basic',
            teamOptions: [],
            workflowOptions: [],
            memLangValue: '',
            termLangValue: '',
            memorySelectionOrigin: '',
            termSelectionOrigin: '',
            memMatchingOptions: [50, 60, 70, 80, 90, 100,],
            memoryList: [],
            termsList: [],
            remarkFileUpload: {
                show: false,
                loading: false,
                accept: '',
            },
            setting: {
                templateName: '',
                teamId: '',
                translationProcessMode: 'T',
                sourceLang: '',
                targetLang: [],
                styleGuideDocs: [],
                remark: '',
                memMatchingRate: 80,
                termIds: [],
                memIds: [],
                mems: [],
                writeableMemId: [],
                writeableTermId: [],
                projectSetting: {
                    multilingualSetting: [],
                    analysisSettings: cloneDeep(config.FILE_ANALYSIS_SETTING_OPTS),
                    autoReplaceSettings: cloneDeep(config.AUTO_REPLACE_OPTS),
                    docSetting: cloneDeep(config.DOC_SETTING_OPTS),
                    qaSetting: {},
                    ratingSettings: {
                        enable: false,
                        threshold: 70,
                    }
                },
                
            },
            multiColumnSettings: null,
        }
    },
    computed: {
        ...mapState({
            LANGUAGE_DICT: state => state.common.LANGUAGE_DICT,
            userInfo: state => state.user.userData,
        }),
	},
    methods: {
        initDetail() {
            let url = `${projectApi.queryTemplateDetail}?id=${this.templateId}`;
            this.$ajax.get(url).then(res => {
                if (res.status === 200) {
                    let memList = [];
                    res.data.templateData.projectSetting.multilingualSetting.map(item => {
                        memList = memList.concat(item.mems);
                    });
                    const param = {
                        ...this.setting,
                        ...res.data,
                        ...res.data.templateData,
                        memMatchingRate: res.data.templateData.projectSetting.multilingualSetting[0].memMatchingRate,
                        termIds: res.data.templateData.projectSetting.multilingualSetting[0].termIds,
                        memIds: res.data.templateData.projectSetting.multilingualSetting[0].memIds,
                        mems: this.handleCleanMems(memList),
                        writeableMemId: res.data.templateData.projectSetting.writeableMemId,
                        writeableTermId: res.data.templateData.projectSetting.writeableTermId,
                        styleGuideDocs: JSON.parse(res.data.templateData.styleGuideDocs),
                    };
                    delete param.templateData;
                    param.projectSetting.ratingSettings = param.projectSetting.ratingSettings ? param.projectSetting.ratingSettings : this.setting.projectSetting.ratingSettings;
                    let list = [];
                     param.projectSetting.multilingualSetting.map(async item => {
                        const eRes = await this.initEngineOptions(item.sourceLang, item.targetLang);
                        item.engineOptions = eRes.domainEngines;
                        const reRes = await this.initReferenceEngineOptions(item.sourceLang, item.targetLang);
                        item.referenceEngineOptions = reRes;
                        list.push(item);
                    })
                    param.projectSetting.multilingualSetting = list;
                    let opts = [];
                    cloneDeep(config.FILE_ANALYSIS_SETTING_OPTS).map(item => {
                        let opt = param.projectSetting.analysisSettings.find(opt => opt.type === item.type);
                        opts.push({...item, ...opt, name: item.name})
                    });
                    param.projectSetting.analysisSettings = opts;
                    opts = [];
                    cloneDeep(config.AUTO_REPLACE_OPTS).map(item => {
                        let opt = param.projectSetting.autoReplaceSettings?.find(opt => opt.type === item.type);
                        opts.push({...item, ...opt, name: item.name})
                    });
                    param.projectSetting.autoReplaceSettings = opts;
                    this.memLangValue = param.targetLang[0]
                    this.termLangValue = param.targetLang[0]
                    this.setting = param;
                    this.$nextTick(() => {
                        this.multiColumnSettings = this.setting.projectSetting.docSetting.multiColumnSettings;
                        delete this.setting.projectSetting.docSetting.multiColumnSettings;
                        this.initDocSettingOpts(this.setting.projectSetting.docSetting);
                        this.initQASetting(this.setting.projectSetting.qaSetting);
                    });

                    // console.log(this.setting);
                }
            });
        },
        settingTabChange(event) {
            switch (event.name) {
                case 'memory':
                    if(this.setting.sourceLang && this.setting.targetLang.length){
                        this.initMemoryList(this.memLangValue);
                    }else {
                        this.$message.error(this.$t('project.project_templateDetail_page_method_settingTabChange_message_1'));
                    }
                    break;
                case 'term':
                    if(this.setting.sourceLang && this.setting.targetLang.length){
                        this.initTermsList(this.termLangValue);
                    }else {
                        this.$message.error(this.$t('project.project_templateDetail_page_method_settingTabChange_message_1'));
                    }
                    break;
            }
        },
        queryWorkflowOptions() {
            let url = projectApi.queryWorkflowList;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    this.workflowOptions = res.data;
                }
            });
        },
        queryTeamOptions() {
            let url = commonApi.queryTeamFilterOptions;
            this.$ajax.get(url).then(res => {
                if(res.status === 200) {
                    this.teamOptions = res.data.teamFilters;
                }
            });
        },
        sourceLangChangeEvent(value){
            this.setting.targetLang = [];
            this.setting.projectSetting.multilingualSetting = [];
        },
        targetLangChangeEvent(value) {
            if(value && value.length > 0) {
                this.memLangValue = value[0];
                this.termLangValue = value[0];
                let list = [];
                value.map(async lang => {
                    let item = this.setting.projectSetting.multilingualSetting.find(ms => ms.targetLang === lang);
                    if(item) {
                        list.push(item);
                    }else {
                        let eRes = await this.initEngineOptions(this.setting.sourceLang, lang);
                        let reRes = await this.initReferenceEngineOptions(this.setting.sourceLang, lang, eRes.recommendationEngine?.domain, eRes.recommendationEngine?.key,);
                        list.push({
                            sourceLang: this.setting.sourceLang,
                            targetLang: lang,
                            engine: eRes.recommendationEngine?.key,
                            domain: eRes.recommendationEngine?.domain,
                            engineOptions: eRes.domainEngines,
                            referenceEngine: '',
                            referenceEngineOptions: reRes,
                            enableAiTrans: false,
                            termIds: [],
                            memIds: [],
                            mems: [],
                        })
                    }
                });
                this.setting.projectSetting.multilingualSetting = list;
            }else {
                this.memLangValue = '';
                this.termLangValue = '';
                this.setting.projectSetting.multilingualSetting = [];
            }
        },
        async initEngineOptions(sourceLang, targetLang) {
            // 初始化预翻译模型列表
            let url = `${projectApi.queryEnginesAndRecommendByLang}?sourceLang=${sourceLang}&targetLang=${targetLang}`;
            const eRes = await this.$ajax.get(url);
            return eRes.data;
        },
        async initReferenceEngineOptions(sourceLang, targetLang, domain, engine){
            let postData = {
				sourceLang,
				targetLang,
            }
            let url = projectApi.queryReferenceEngineList;
            const res = await this.$ajax.post(url, postData);
            return res.data;
        },
		initMemoryList(targetLang, ids = []) {
			this.setting.memoryTableSelection = [];
			let url = `${memoryApi.memoryDB}?pageNumber=1&pageSize=1000&type=new` +
				`&sourceLang=${this.setting.sourceLang}&targetLang=${targetLang}&teamId=${this.setting.teamId || ''}`;
			this.$ajax.get(url).then((res) => {
				if (res.status === 200) {
					this.memoryList = res.data.records.map(item => {
                        let mem = this.setting.mems.find(m => m.memId + '' === item.memId);
                        return {
                            ...item,
                            setting: mem ? mem.penalties : item.setting,
                        }
                    });
                    this.$nextTick(() =>{
                        if(ids.length){
                            this.setting.memIds = this.setting.memIds.concat(ids);
                            for(let item of this.memoryList){
                                if(ids.includes(item.memId)){
                                    this.memorySelectionOrigin = '';
                                    this.$refs.memoryTable.toggleRowSelection(item, true);
                                }
                            }
                        }else {
                            this.setMemorySelection();
                        }
                    });
				}
			});
		},
        memLangSelectChange(val) {
            this.initMemoryList(val);
        },
        termLangSelectChange(val) {
            this.initTermsList(val);
        },
        setMemorySelection(){
            this.$nextTick(() =>{
                this.memoryList.map(row => {
                    if(this.setting.memIds && this.setting.memIds.indexOf(row.memId) !== -1){
                        this.memorySelectionOrigin = 'init';
                        this.$refs.memoryTable.toggleRowSelection(row, true);
                    }
                });
                setTimeout(()=>{
                    this.memorySelectionOrigin = '';
                }, 200);
            });
        },
        getMemoryPenaltyPointsInputStatus(row) {
            return !this.setting.memIds.includes(row.memId);
        },
        handleMemoryPenaltyPointsChange(val, row) {
            let index = this.setting.mems.findIndex(item => item.memId + '' === row.memId);
            if(index > -1){
                this.setting.mems.splice(index, 1, {memId: row.memId, penalties: row.setting})
            }else {
                this.setting.mems.push({memId: row.memId, penalties: row.setting});
            }
        },
        handleMemoryTableSelectionChange(val){
            this.setting.memoryTableSelection = val;
            if(this.memorySelectionOrigin === ''){
                let ids = val.map(item => item.memId);
                let tmpIds = [];
                let tmpWriteableId = [];
                this.setting.memIds.map(id => {
                    let mem = this.memoryList.find(it => it.memId === id);
                    if(!mem && id) tmpIds.push(id);
                })
                
                this.setting.writeableMemId.map(id => {
                    let mem = this.memoryList.find(it => it.memId === id);
                    if(!mem) {
                        tmpWriteableId.push(id)
                    }else {
                        if(ids.includes(id)) {
                            tmpWriteableId.push(id);
                        }
                    }
                });
                this.setting.memIds = [...new Set(tmpIds.concat(ids))];
                this.setting.writeableMemId = [...new Set(tmpWriteableId)];
            }else {
                this.memorySelectionOrigin = '';
            }
        },
        
        handleMemoryWriteChange(val, row) {
            if(val){
                let hitItem = this.memoryList.filter(item => this.setting.writeableMemId.includes(item.memId)/*  && row.sourceLang === item.sourceLang && row.targetLang === item.targetLang */);
                if(hitItem.length > 0) {
                    let index = this.setting.writeableMemId.findIndex(id => id === hitItem[0].memId);
                    this.setting.writeableMemId.splice(index, 1, row.memId);
                }else {
                    this.setting.writeableMemId.push(row.memId);
                }
                this.$refs.memoryTable.toggleRowSelection(row, true);
            }else {
                let index = this.setting.writeableMemId.findIndex(id => id === row.memId);
                this.setting.writeableMemId.splice(index, 1);
            }
        },
        initTermsList(targetLang, ids = []) {
			this.setting.termsTableSelection = [];
			let url = `${termApi.termDB}?pageNumber=1&pageSize=1000` +
				`&sourceLang=${this.setting.sourceLang}&targetLang=${targetLang}&teamId=${ this.setting.teamId || ''}`;
			this.$ajax.get(url).then((res) => {
				if (res.status === 200) {
					this.termsList = res.data.records;
                    this.$nextTick(() =>{
                        if(ids.length){
                            this.setting.termIds = this.setting.termIds.concat(ids);
                            for(let item of this.termsList){
                                if(ids.includes(item.termId)){
                                    this.termSelectionOrigin = '';
                                    this.$refs.termsTable.toggleRowSelection(item, true);
                                }
                            }
                        }else {
                            this.setTermSelection();
                        }
                    });
				}
			});
		},
        handleTermWriteChange(val, row) {
            if(val){
                let hitItem = this.termsList.filter(item => this.setting.writeableTermId.includes(item.termId) /* && row.sourceLang === item.sourceLang && row.targetLang === item.targetLang */);
                if(hitItem.length > 0) {
                    let index = this.setting.writeableTermId.findIndex(id => id === hitItem[0].termId);
                    this.setting.writeableTermId.splice(index, 1, row.termId);
                }else {
                    this.setting.writeableTermId.push(row.termId);
                }
                this.$refs.termsTable.toggleRowSelection(row, true);
            }else {
                let index = this.setting.writeableTermId.findIndex(id => id === row.termId);
                this.setting.writeableTermId.splice(index, 1);
            }
        },
        handleTermsTableSelectionChange(val){
            this.setting.termsTableSelection = val;
            if(this.termSelectionOrigin === ''){
                let ids = val.map(item => item.termId);
                let tmpIds = [];
                let tmpWriteableId = [];
                this.setting.termIds.map(id => {
                    let term = this.termsList.find(it => it.termId === id);
                    if(!term && id) tmpIds.push(id);
                })
                this.setting.writeableTermId.map(id => {
                    let term = this.termsList.find(it => it.termId === id);
                    if(!term) {
                        tmpWriteableId.push(id);
                    }else {
                        if(ids.includes(id)) {
                            tmpWriteableId.push(id);
                        }
                    }
                })
                this.setting.termIds = [...new Set(tmpIds.concat(ids))];
                this.setting.writeableTermId = [...new Set(tmpWriteableId)];
            }else {
                this.termSelectionOrigin = '';
            }
        },
        setTermSelection(){
            let self = this;
            this.$nextTick(() =>{
                this.termsList.map(row => {
                    if(this.setting.termIds && this.setting.termIds.indexOf(row.termId) !== -1){
                        this.termSelectionOrigin = 'init';
                        this.$refs.termsTable.toggleRowSelection(row, true);
                    }
                });
                setTimeout(()=>{
                    this.termSelectionOrigin = '';
                }, 200);
            });
        },
        gotoMemoryPage() {
            let list = [];
            this.setting.targetLang.map(target => {
                list.push({source: this.setting.sourceLang, target, object: {}});
            })
            this.$refs.createMemoryDialog.setShow({list});
		},
        gotoTermPage() {
            let list = [];
            this.setting.targetLang.map(target => {
                list.push({source: this.setting.sourceLang, target, object: {}});
            })
            this.$refs.createTermDialog.setShow({list});
		},
        docSettingCheckAllChange(val,index){
            this.setting.projectSetting.docSetting[index]['checkAll'] = val;
            this.setting.projectSetting.docSetting[index]['indeterminate'] = false;
            let tmpOptions = this.setting.projectSetting.docSetting[index]['options'];
            tmpOptions.map((opt, oIndex)=>{
                tmpOptions[oIndex]['value'] = val;
            });
            this.setting.projectSetting.docSetting[index]['options'] = tmpOptions;
        },
        docSettingCheckChange(val,index,oIndex){
            let checkedCount = 0;
            this.setting.projectSetting.docSetting[index]['options'][oIndex]['value'] = val;
            let options = this.setting.projectSetting.docSetting[index]['options'];
            options.map(opt=>{
                if(opt.value === true){
                    checkedCount = checkedCount + 1;
                }
            });
            this.setting.projectSetting.docSetting[index]['checkAll'] = checkedCount === options.length;
            this.setting.projectSetting.docSetting[index]['indeterminate'] = checkedCount > 0 && checkedCount < options.length;
        },
        showMultiColumnExcelParseDialogEvent() {
            if(this.setting.targetLang.length === 0) {
                this.$message.warning(this.$t('project.project_create_page_method_showMultiColumnExcelParseDialogEvent_message_1'));
                return;
            }
            let settings = {
                notParseFirstRow: false,
                source: {lang: this.setting.sourceLang, col: ''},
                targets: this.setting.targetLang.map(lang => ({lang, col: ''})),
            }
            if(this.multiColumnSettings) {
                settings.notParseFirstRow = this.multiColumnSettings.notParseFirstRow;
                if(this.multiColumnSettings.source.lang === settings.source.lang) {
                    settings.source = {...this.multiColumnSettings.source};
                }
                this.multiColumnSettings.targets.map(item => {
                    let tIndex = settings.targets.findIndex(t => t.lang === item.lang);
                    if(tIndex > -1) {
                        settings.targets[tIndex] = {...item};
                    }
                });
            }
            this.$refs.multiColumnExcelParseRef.setShow({...settings, enable: true});
        },
        saveMultiColumnSetting(settings) {
            this.multiColumnSettings = settings;
        },
        validateMultiColumnSettings() {
            if(!this.multiColumnSettings) {
                setTimeout(() => {
                    this.$message.error(this.$t('project.project_create_page_method_validateMultiColumnSettings_message_1'));
                }, 100);
                return false;
            }
            let emptyTargets = this.multiColumnSettings.targets.filter(item => !item.col);
            let tLangs = this.multiColumnSettings.targets.filter(item => !this.setting.targetLang.includes(item.lang));
            if(!this.multiColumnSettings.source.col || 
                emptyTargets.length > 0 || 
                this.multiColumnSettings.targets.length !== this.setting.targetLang.length || 
                tLangs.length > 0) {
                setTimeout(() => {
                    this.$message.error(this.$t('project.project_create_page_method_validateMultiColumnSettings_message_2'));
                }, 100);
                return false;
            }
            return true;
        },
        /**根据设置配置接口返回的数据设置默认选中 */
        initDocSettingOpts(docSetting){
            if(docSetting){
                let initDocSetting = cloneDeep(config.DOC_SETTING_OPTS);
                
                initDocSetting.map((setting, i) => {
                    let checkedCount = 0;
                    setting.options.map((opt, j) => {
                        let key = opt.key;
                        let val = docSetting[key];
                        initDocSetting[i]['options'][j]['value'] = val;
                        if(val){
                            checkedCount = checkedCount + 1;
                        }
                    });
                    initDocSetting[i]['checkAll'] = checkedCount === setting.options.length;
                    initDocSetting[i]['indeterminate'] = checkedCount > 0 && checkedCount < setting.options.length;
                });
                this.setting.projectSetting.docSetting = initDocSetting;
            }
        },
        async initQASetting(setting){
            const res = await this.$ajax.get(qaApi.queryQaConfig);
            if(res.status === 200){
                let options = [];
                let checkQa = false;
                if(setting){
                    checkQa = setting.checkQa;
                    res.data.options.map(item=>{
                        options.push({...item, selected: setting.selected[item.code]});
                    });
                }else {
                    options = res.data.options;
                    checkQa = res.data.checkQa;
                }
                this.setting.projectSetting.qaSetting = {checkQa, options};
            }
        },
        submitUploadRemarkFile(){
            let files = this.$refs.remarkFileUploadDom.getOssFiles();
            let list = [];
            files.map(item => {
                list.push({...item, time: moment().format('YYYY-MM-DD HH:mm:ss')});
            });
            this.setting.styleGuideDocs = this.setting.styleGuideDocs.concat(list);
            this.remarkFileUpload.loading = false;
            this.remarkFileUpload.show = false;
        },
        deleteRemarkFile(scope){
            this.setting.styleGuideDocs.splice(scope.$index, 1);
        },

        handleCleanMems(list) {
            let ids = [];
            let result = [];
            let _list = list || this.setting.mems;
            _list.map(mem => {
                if(!ids.includes(mem.memId)) {
                    ids.push(mem.memId);
                    result.push(mem);
                }
            });
            return result;
        },
        async saveTemplateBtnEvent() {
            let qaSelected = {};
            this.setting.projectSetting.qaSetting.options.map(item => {
                qaSelected[item.code] = item.selected;
            });
            let docSetting = {};
             this.setting.projectSetting.docSetting.map(tItem => {
                tItem.options.map(oItem => {
                    docSetting[oItem.key] = oItem.value;
                });
            });
            docSetting['multiColumnSettings'] = this.multiColumnSettings;
            const _multilingualSetting = cloneDeep(this.setting.projectSetting.multilingualSetting);
            let postData = {
                id: this.templateId || undefined,
                teamId: this.setting.teamId,
                templateName: this.setting.templateName,
                remark: this.setting.remark,
                styleGuideDocs: this.setting.styleGuideDocs,
                projectSetting: {
                    docSetting,
                    qaSetting: {
                        checkQa: this.setting.projectSetting.qaSetting.checkQa,
                        selected: qaSelected,
                    },
                    writeableMemId: Array.from(new Set(this.setting.writeableMemId)),
                    writeableTermId: Array.from(new Set(this.setting.writeableTermId)),
                    analysisSettings: this.setting.projectSetting.analysisSettings,
                    translationProcess: this.setting.translationProcessMode,
                    ratingSettings: this.setting.projectSetting.ratingSettings,
                    autoReplaceSettings:this.setting.projectSetting.autoReplaceSettings,
                    multilingualSetting: _multilingualSetting.map(item => {
                        delete item.engineOptions;
                        delete item.referenceEngineOptions;
                        return {
                            ...item,
                            enableAiTrans: item.engine !== 'NONE',
                            engine: item.engine === 'NONE' ? null : item.engine,
                            domain: item.engine === 'NONE' ? null : item.domain,
                            termIds: Array.from(new Set(this.setting.termIds)),
                            memIds: Array.from(new Set(this.setting.memIds)),
                            mems: this.handleCleanMems(),
                            memMatchingRate: this.setting.memMatchingRate,
                        }
                    }),
                },
            };
            if(!postData.templateName) {
                this.$message.error(this.$t('project.project_templateDetail_page_method_saveTemplateBtnEvent_message_3'));
                return;
            }
            if(!postData.teamId) {
                this.$message.error(this.$t('project.project_templateDetail_page_method_saveTemplateBtnEvent_message_4'));
                return;
            }
            if(!this.setting.sourceLang) {
                this.$message.error(this.$t('project.project_templateDetail_page_method_saveTemplateBtnEvent_message_5'));
                return;
            }
            if(this.setting.targetLang.length === 0) {
                this.$message.error(this.$t('project.project_templateDetail_page_method_saveTemplateBtnEvent_message_6'));
                return;
            }
            if (docSetting['multiColumn']) {
                let vmc = this.validateMultiColumnSettings();
                if(!vmc) {
                    this.showMultiColumnExcelParseDialogEvent();
                    return;
                }
            }
            // console.log('saveTemplateBtnEvent:: setting: %o, postData: %o', this.setting, postData);
            try {
                this.saveLoading = true;
                let res;
                if(this.templateId){
                    res = await this.$ajax.put(projectApi.editTemplate, postData);
                    if(res.status === 200){
                        this.$message.success(this.$t('project.project_templateDetail_page_method_saveTemplateBtnEvent_message_1'));
                    }
                }else {
                    res = await this.$ajax.post(projectApi.editTemplate, postData);
                    if(res.status === 200){
                        this.templateId = res.data;
                        this.$message.success(this.$t('project.project_templateDetail_page_method_saveTemplateBtnEvent_message_2'));
                        this.$router.replace({path: '/project/templateDetail', query: {id: res.data}});
                    }
                }
            } catch (error) {

            } finally {
                this.saveLoading = false;
            }
        }
    },
    created() {
        if (this.$route.query.id) {
            this.templateId = this.$route.query.id;
            this.initDetail();
        }else {
            this.initQASetting();
        }
        this.queryWorkflowOptions();
        this.queryTeamOptions();
    },
    mounted() {
        this.$shortcut.bind('ctrl+s, ⌘+s', ()=>{
            this.$refs.saveBtn.$el.click();
        });
    },
    beforeDestroy() {
        this.$shortcut.unbind('ctrl+s, ⌘+s');
    }
}
</script>
<style lang="scss" scoped>
.template-detail-page {

    .setting-engine-table{
        th, td {
            text-align: left;
            padding: 10px;
        }
        th {
            font-size: 12px;
            &:first-child {
                padding-left: 0;
            }
        }
        td {
            font-size: 15px;
            &:first-child {
                padding-left: 0;
            }
        }
    }
    .setting-grid {
        display: grid;
        grid-gap: 0px;
        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    }
    .qa-setting-panel{
        background-color: #FFFFFF;
        .option-wrapper {
            box-sizing: border-box;
            .block-title{
                font-size: 14px;
                font-weight: 600;
                padding: 15px 30px 0 30px;
            }
            .option-list{
                display: grid;
                padding: 15px 30px;
                grid-gap: 0px;
                grid-template-columns: repeat(auto-fill,minmax(160px,1fr));
                // flex-wrap: wrap;
                .item{
                    // width: 7%;
                    padding: 10px 0;
                    word-break: break-all;
                    word-wrap: break-word;
                    display: flex;
                    align-items: center;
                }
            }
        }
        
    }
}
</style>
